import React from 'react';
import CloseImg from './assets/close.svg';
import NewImg from './assets/new.svg';
import SendImg from './assets/send.svg';
import styles from './style.css';

/**
 * Side panel component with control buttons
 */
export const SidePanel = ({ buttonsHidden, setShowChat, isResponding, newConversation, send }) => {
    if (buttonsHidden) {
        return (
            <div className={styles.sidepanel}>
                <div className={styles.upper}>
                    <button className={styles.sideButton} onClick={() => setShowChat(false)}>
                        <img className={styles.img} src={CloseImg} alt="Close" />
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.sidepanel}>
            <div className={styles.upper}>
                <button className={styles.sideButton} onClick={() => setShowChat(false)}>
                    <img className={styles.img} src={CloseImg} alt="Close" />
                </button>
                <button className={[styles.sideButton, styles.transparent50, isResponding ? styles.disabled : ""].join(" ")} onClick={newConversation}>
                    <img className={styles.img} src={NewImg} alt="New" />
                </button>
            </div>
            <div className={styles.lower}>
                <button
                    className={[styles.sideButton, styles.sideButtonLower, isResponding ? styles.disabled : ""].join(" ")}
                    onClick={send}
                >
                    <img className={styles.img} src={SendImg} alt="Send" />
                </button>
            </div>
        </div>
    );
};
